@for (item of navItems; track item; let itemIndex = $index) {
<ul class="nav-vertical -menu">
  <li class="nav-vertical -menu -item">
    <div
      class="nav-vertical -menu -item -container d-flex justify-content-between"
      [ngClass]="{ '-active': item.active }">
      <app-link
        class="nav-vertical -menu -item -link -fontMedium"
        (click)="toggleChild('p', itemIndex)"
        [ngClass]="{ '-active': item.active }"
        [to]="item.path ? item.path : undefined"
        [disableRoute]="item.path ? false : true"
        [externaloverride]="item.newTab">
        {{ item.title }}
      </app-link>
      @if (item.children) {
      <button-icon
        iconcolor="-colorSupportingWhite"
        iconattributes="-sm15"
        iconhovercolor="-colorPrimaryGreen"
        (click)="toggleChild('p', itemIndex)"
        [icon]="_closedStates['p'][itemIndex]['icon']">
      </button-icon>
      } @if (item.newTab) {
      <app-link [to]="item.path ? item.path : undefined" [externaloverride]="item.newTab">
        <button-icon
          iconcolor="-colorSupportingWhite"
          iconattributes="-sm15"
          iconhovercolor="-colorPrimaryGreen"
          (click)="toggleChild('p', itemIndex)"
          icon="external-link">
        </button-icon>
      </app-link>
      }
    </div>
    @if (item.children) {
    <ul [@_closed]="_closedStates['p'][itemIndex]['state']" class="nav-vertical -menuChild">
      @for (child of item.children; track child; let childIndex = $index) {
      <li class="nav-vertical -menuChild -item">
        <div
          class="nav-vertical -menuChild -item -container d-flex align-items-start"
          [ngClass]="{ '-hasIcon': child.children }">
          @if (child.children) {
          <button-icon
            iconcolor="-colorSupportingWhite"
            iconattributes="-sm15"
            iconhovercolor="-colorPrimaryGreen"
            (click)="toggleChild('c', childIndex)"
            [icon]="_closedStates['c'][childIndex]['icon']">
          </button-icon>
          }
          <app-link
            class="nav-vertical -menuChild -item -link -fontXSmall"
            [ngClass]="{ '-active': child.active }"
            [to]="child.path"
            [disableRoute]="!child.path">
            {{ child.title }}
          </app-link>
        </div>
        @if (child.children) {
        <ul class="nav-vertical -menuGrandchild" [@_closed]="_closedStates['c'][childIndex]['state']">
          @for (grandchild of child.children; track grandchild) {
          <li class="nav-vertical -menuGrandchild -item">
            <app-link
              class="nav-vertical -menuGrandchild -item -link -fontXSmall"
              [ngClass]="{ '-active': grandchild.active }"
              [to]="grandchild.path">
              {{ grandchild.title }}
            </app-link>
          </li>
          }
        </ul>
        }
      </li>
      }
    </ul>
    }
  </li>
</ul>
}
